import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { ROUTES } from "../config/constants";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        {/* 404 Number */}
        <div className="text-center mb-6">
          <h1 className="text-8xl font-bold text-blue-700 mb-2">404</h1>
          <div className="h-1 w-20 mx-auto bg-blue-700 rounded"></div>
        </div>

        {/* Message */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Halaman Tidak Ditemukan
          </h2>
          <p className="text-gray-600">
            Maaf, halaman yang Anda cari tidak tersedia atau telah dipindahkan.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate(ROUTES.HOME)}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            <Home size={20} />
            Ke Halaman Utama
          </button>
          <button
            onClick={() => navigate(-1)}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft size={20} />
            Kembali
          </button>
        </div>
      </div>
    </div>
  );
}
